import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "block truncate" }
const _hoisted_3 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "block truncate font-normal" }

import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { ChevronUpDownIcon, CheckIcon } from "@heroicons/vue/24/outline";
import { ref, PropType, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectList',
  props: {
  options: {
    type: Array as unknown as PropType<{ value: string; name: string }[]>,
    required: true,
  },
  label: {
    type: String,
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  defaultSelected: {
    type: [String, Array] as unknown as PropType<string | string[]>,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  controller: {
    type: Object,
    default: () => ({}),
  },
  readonly: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:selected"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;
const selected = ref(props.defaultSelected);

watch(
  () => props.defaultSelected,
  (value) => {
    selected.value = value;
  },
);

const handleDisplayTypeChange = (value: string) => {
  if (props.multiple) {
    if (selected.value.includes(value)) {
      selected.value = (selected.value as string[]).filter((item) => item !== value);
    } else {
      selected.value = [...selected.value, value];
    }
  } else {
    selected.value = value;
  }

  emits("update:selected", selected.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Listbox), _mergeProps({
    as: "div",
    modelValue: selected.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
    style: {"min-width":"180px"},
    multiple: __props.multiple
  }, __props.controller, { disabled: __props.readonly }), {
    default: _withCtx(() => [
      (__props.label)
        ? (_openBlock(), _createBlock(_unref(ListboxLabel), {
            key: 0,
            class: "text-sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.label), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ListboxButton), {
          class: _normalizeClass([
          'relative rounded-md py-1.5 pl-3 pr-10 text-xs text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6 w-full',
          __props.readonly ? 'bg-gray-50 cursor-default' : 'bg-white',
        ])
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(__props.multiple
            ? __props.placeholder
            : __props.options.find((type) => type.value === selected.value || type.value === __props.controller.value)
                ?.name || __props.placeholder), 1),
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_unref(ChevronUpDownIcon), {
                class: "h-5 w-5 text-gray-400",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_Transition, {
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ListboxOptions), { class: "absolute z-50 mt-1 max-h-60 overflow-auto rounded-md bg-white py-1 text-xs shadow-lg ring-1 ring-yellow-500/5 focus:outline-none sm:text-sm w-full" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                  return (_openBlock(), _createBlock(_unref(ListboxOption), {
                    as: "template",
                    key: option.value,
                    value: option.value
                  }, {
                    default: _withCtx(({ active, selected }) => [
                      _createElementVNode("li", {
                        class: _normalizeClass([
                (active || selected) && 'bg-yellow-100',
                'relative cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900',
              ]),
                        onClick: ($event: any) => (handleDisplayTypeChange(option.value))
                      }, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(option.name), 1),
                        (selected && __props.multiple)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass([
                  active ? 'text-white' : 'text-indigo-600',
                  'absolute inset-y-0 right-0 flex items-center pr-4',
                ])
                            }, [
                              _createVNode(_unref(CheckIcon), {
                                class: "h-5 w-5",
                                "aria-hidden": "true"
                              })
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_4)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 16, ["modelValue", "multiple", "disabled"]))
}
}

})